// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

.searchBarResultGridContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.searchBarResultGridHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 8px 0;
  flex-shrink: 0;
}

.searchBarPageSizeSection {
  display: flex;
  align-items: center;
  gap: 8px;
}

.searchBarPageSizeLabel {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
}

.searchBarPageSizeSelect {
  min-width: 60px;
  height: 28px;
}

.searchBarPageSizeSelect .MuiSelect-select {
  padding: 4px 8px;
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
}

.searchBarColumnFilterSection {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}

.searchBarColumnFilterSection:hover {
  background-color: var(--inputbackgroundColor);
}

.searchBarColumnFilterImage {
  width: 16px;
  height: 16px;
}

.searchBarColumnFilterLabel {
  font-size: var(--default-FontSize);
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  white-space: nowrap;
}

.searchBarGridWrapper {
  flex: 1;
  width: 100%;
  min-height: 0;
  overflow: hidden;
}

.searchBarGridWrapper .ag-theme-alpine,
.searchBarGridWrapper .ag-root-wrapper {
  height: 100% !important;
  width: 100% !important;
}

/* Allow AG Grid filter popups to render properly inside the modal */
.searchBarGridWrapper .ag-theme-alpine .ag-popup {
  height: auto;
}

/* AG Grid filter popups need to be above modalbody and all modal content */
.modalmainpage .ag-popup {
  z-index: 2008 !important;
  height: auto !important;
}

.modalmainpage .ag-popup-child {
  z-index: 2008 !important;
}

/* Column Filter Dialog header layout */
.workFlowFilterColumnSection .filterColumnHeaderMainSection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.workFlowFilterColumnSection .filterColumnHeaderMainSection .title {
  margin: 0 !important;
}

.workFlowFilterColumnSection
  .filterColumnHeaderMainSection
  .filterColumnHeaderCloseSection {
  cursor: pointer;
}

.workFlowFilterColumnSection .MuiDialogTitle-root {
  padding: 0;
}

/* Column Filter Dialog checkbox colors */
.workFlowFilterColumnSection
  .filterColumnContentSection
  .MuiCheckbox-root.Mui-checked
  .MuiSvgIcon-root {
  color: var(--unStyledSwitchColor);
}

.workFlowFilterColumnSection
  .filterColumnContentSection
  .MuiCheckbox-root
  .MuiSvgIcon-root {
  color: var(--unStyledSwitchColor);
}

.workFlowFilterColumnSection
  .filterColumnContentSection
  .MuiCheckbox-root.Mui-disabled
  .MuiSvgIcon-root {
  color: var(--disableMenuColor);
}

.workFlowFilterColumnSection
  .filterColumnContentSection
  .MuiFormControlLabel-label {
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/searchBar/SearchBarResultGrid.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;EACtC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,YAAY;AACd;;AAEA,2EAA2E;AAC3E;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,yCAAyC;AACzC;;;;EAIE,iCAAiC;AACnC;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;EAGE,iBAAiB;AACnB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n.searchBarResultGridContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.searchBarResultGridHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 0 8px 0;\n  flex-shrink: 0;\n}\n\n.searchBarPageSizeSection {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.searchBarPageSizeLabel {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n}\n\n.searchBarPageSizeSelect {\n  min-width: 60px;\n  height: 28px;\n}\n\n.searchBarPageSizeSelect .MuiSelect-select {\n  padding: 4px 8px;\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n}\n\n.searchBarColumnFilterSection {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.searchBarColumnFilterSection:hover {\n  background-color: var(--inputbackgroundColor);\n}\n\n.searchBarColumnFilterImage {\n  width: 16px;\n  height: 16px;\n}\n\n.searchBarColumnFilterLabel {\n  font-size: var(--default-FontSize);\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  white-space: nowrap;\n}\n\n.searchBarGridWrapper {\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.searchBarGridWrapper .ag-theme-alpine,\n.searchBarGridWrapper .ag-root-wrapper {\n  height: 100% !important;\n  width: 100% !important;\n}\n\n/* Allow AG Grid filter popups to render properly inside the modal */\n.searchBarGridWrapper .ag-theme-alpine .ag-popup {\n  height: auto;\n}\n\n/* AG Grid filter popups need to be above modalbody and all modal content */\n.modalmainpage .ag-popup {\n  z-index: 2008 !important;\n  height: auto !important;\n}\n\n.modalmainpage .ag-popup-child {\n  z-index: 2008 !important;\n}\n\n/* Column Filter Dialog header layout */\n.workFlowFilterColumnSection .filterColumnHeaderMainSection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n}\n\n.workFlowFilterColumnSection .filterColumnHeaderMainSection .title {\n  margin: 0 !important;\n}\n\n.workFlowFilterColumnSection\n  .filterColumnHeaderMainSection\n  .filterColumnHeaderCloseSection {\n  cursor: pointer;\n}\n\n.workFlowFilterColumnSection .MuiDialogTitle-root {\n  padding: 0;\n}\n\n/* Column Filter Dialog checkbox colors */\n.workFlowFilterColumnSection\n  .filterColumnContentSection\n  .MuiCheckbox-root.Mui-checked\n  .MuiSvgIcon-root {\n  color: var(--unStyledSwitchColor);\n}\n\n.workFlowFilterColumnSection\n  .filterColumnContentSection\n  .MuiCheckbox-root\n  .MuiSvgIcon-root {\n  color: var(--unStyledSwitchColor);\n}\n\n.workFlowFilterColumnSection\n  .filterColumnContentSection\n  .MuiCheckbox-root.Mui-disabled\n  .MuiSvgIcon-root {\n  color: var(--disableMenuColor);\n}\n\n.workFlowFilterColumnSection\n  .filterColumnContentSection\n  .MuiFormControlLabel-label {\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
